import { Component, Input } from '@angular/core';

export enum AlertType {
    IMPORTANT = 'important',
    WARNING = 'warning'
}

@Component({
    selector: 'syn-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss']
})
export class AlertComponent {

    @Input() type = AlertType.IMPORTANT;

}
